import React, { useState, useRef } from "react";
import "../../../website/feedTypes/feedComponents/uploadFeed.scss";
import {
  createFeed,
  fileUpload,
  fileUploadAfterSignURL,
  teacherUploadHomeWork,
  teacherUploadHomeWorkMultiple,
} from "../../../../actions/emActions";
import Dropzone from "react-dropzone";
import { Spinner } from "reactstrap";
import { connect } from "react-redux";

const UploadHomeworkMultiple = (props) => {
  const { programs } = props;
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [text, setText] = useState("");
  const [imageId, setimageId] = useState("");
  const [feedType, setfeedType] = useState();
  const [teacherId, setteacherId] = useState("");
  const [studentIds, setstudentIds] = useState("");
  const [programInfo, setprogramInfo] = useState("");
  const [worksheetFileData, setworksheetFileData] = useState("");
  const [uploadLoading, setuploadLoading] = useState(false);
  const [programNameState, setprogramNameState] = useState({});

  const fileInputRef = useRef(null);

  if (props.programNameState.programName !== programNameState) {
    const { programNameState } = props;
    console.log("Program Info", programNameState);
    setprogramNameState(programNameState.programName);
    setprogramInfo(programNameState);

    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    if (tutorData && programNameState) {
      setteacherId(tutorData.user.user_id);

      //To Get Students Logic
      let TeacherStudent = tutorData.teacher_students;

      if (TeacherStudent[programNameState.programName]) {
        var studentId = TeacherStudent[programNameState.programName].map((item) => item.student_id);

        setstudentIds(studentId.join(","));
      }
    }
  }

  const handleFileChange = (acceptedFiles) => {
    debugger;
    const newSelectedFiles = [...selectedFiles, ...acceptedFiles];
    setSelectedFiles(newSelectedFiles);

    const newPreviews = acceptedFiles.map((file, index) => ({
      id: index,
      file,
      preview: URL.createObjectURL(file),
      isImage: file.type.startsWith("image/"),
      isVideo: file.type.startsWith("video/"),
    }));
    setPreviews([...previews, ...newPreviews]);
  };

  const handleChooseFile = () => {
    fileInputRef.current.click();
  };

  console.log("selectedFile", worksheetFileData);
  console.log("programInfo", programInfo);
  //   console.log("programInfo", programInfo && JSON.parse(programInfo)?.progid);
  // console.log("programInfo", JSON.parse(programInfo));

  const uploadFeedFunc = () => {
    setuploadLoading(true);

    fileUpload(selectedFiles, teacherId.toString(), "tutor")
      .then((res) => {
        if (res?.status === 201) {
          const feedData = res?.data.map((item) => {
            return {
              message: text,
              url: item.url,
              url_type: item.filetype,
            };
          });
          debugger;

          teacherUploadHomeWorkMultiple(
            "0",
            0,
            programInfo?.courseId,
            programInfo?.program,
            teacherId,
            programInfo?.slotId,
            "teacher_upload_multiple",
            studentIds,
            feedData
          ).then((res) => {
            window.location.reload();
            setuploadLoading(false);
          });
        } else {
          window.alert("Some Error occurred 7");
          setuploadLoading(false);
        }
      })
      .catch((err) => {
        window.alert("Some Error occurred 8", err);
        setuploadLoading(false);
      });
  };
  // remove selected image from images
  const handleRemoveImg = (index) => {
    const updatedSelectedFiles = [...selectedFiles];
    updatedSelectedFiles.splice(index, 1);

    const updatedPreviews = [...previews];
    updatedPreviews.splice(index, 1);

    setSelectedFiles(updatedSelectedFiles);
    setPreviews(updatedPreviews);
  };

  return (
    <div className="row">
      <div className="col-md-6">
        <div className="card text-left uploadFeed">
          <div className="card-body">
            <div className="d-flex justify-content-between">
              <h5 className="card-title mb-0">Upload Photo or Video</h5>
            </div>
            <form className="mt-3 row">
              <div className="col-md-12">
                <Dropzone
                  accept="image/*, video/*"
                  maxFiles={2}
                  onDrop={(acceptedFiles) => handleFileChange(acceptedFiles)}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps({ className: "dropzone" })}>
                      <input {...getInputProps()} />
                      <p>Drag 'n' drop file here, or click to select images/video</p>
                    </div>
                  )}
                </Dropzone>
              </div>
              {selectedFiles.length > 0 && (
                <>
                  <div className="col-md-8">
                    <div className="p-2">
                      {programs?.map((item) => (
                        <div>
                          <input
                            type="radio"
                            onClick={(e) => setprogramInfo(e.target.value)}
                            value={JSON.stringify(item)}
                            checked={
                              programInfo && JSON.parse(programInfo)?.progid === item?.progid
                            }
                          />
                          <label className="ml-2">{item?.prog_name}</label>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-12 mt-3">
                    <textarea
                      type="text"
                      placeholder="Add caption here"
                      className="form-control form-control-sm"
                      id="textInput"
                      value={text}
                      onChange={(e) => setText(e.target.value)}
                    />
                  </div>
                  {previews.map((preview, index) => (
                    <div className="col-md-4 mt-4" key={index}>
                      {preview.isImage ? (
                        <div>
                          <img
                            className="uploadedImg"
                            src={preview.preview}
                            alt={`Preview ${index}`}
                            // style={{ width: "100%", height: "auto" }}
                          />
                          <i
                            onClick={() => handleRemoveImg(index)}
                            className="fa fa-times closeIcon"
                          />
                        </div>
                      ) : preview.isVideo ? (
                        <div>
                          <video controls width={134} height={134}>
                            <source src={preview.preview} type={preview.file.type} />
                            Your browser does not support the video tag.
                          </video>
                          <i className="fa fa-times closeIcon" />
                        </div>
                      ) : (
                        <p>Unsupported file type</p>
                      )}
                    </div>
                  ))}
                </>
              )}
              <div className="col-md-12 text-right mt-3">
                <button
                  // type="submit"
                  disabled={selectedFiles.length > 0 && programInfo && !uploadLoading ? false : true}
                  className="uploadBtn"
                  onClick={() => uploadFeedFunc()}
                >
                  {uploadLoading ? <Spinner size="sm" /> : "Upload"}
                </button>
              </div>
              {/* <div className="col-md-12 mt-3">
              <button type="button" className="chooseFileBtn" onClick={handleChooseFile}>
              Choose Image or Video
              </button>
              </div>
              <div className="form-group">
              <input
              type="file"
              className="form-control-file d-none"
              id="fileInput"
              accept="image/*, video/*"
              onChange={handleFileChange}
              ref={fileInputRef}
              />
            </div> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    programNameState: state.feedTutorRed.programName,
  };
}
export default connect(mapStateToProps, null)(UploadHomeworkMultiple);
